package team.platforma.dictionary_data.di

import org.koin.core.module.Module
import org.koin.dsl.module

actual val dictionaryDatabaseModule = module {  }